export interface Notification {
  id: string;
  date: number;
  text_en: string;
  text_fr: string;
  seen: boolean;
  level: null | NotificationLevel;
  services: string[];
  remember_dismissal: boolean | string | number;
  link: string;
}

export enum NotificationLevel {
  INFO = 'info',
  WARNING = 'warning',
  CRITICAL = 'critical',
}

export interface INotificationState {
  notifications: Record<string, Notification>;
}
